import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Anchor } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m?.[1];
    if (!sessionId) {
      nav("/connexion");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        // Clean URL fragment & redirect
        window.history.replaceState({}, "", window.location.pathname);
        nav("/mon-espace");
      } catch {
        nav("/connexion");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-blanc grid place-items-center">
      <div className="text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-ocean text-blanc grid place-items-center animate-pulse">
          <Anchor className="w-6 h-6" />
        </div>
        <p className="mt-4 font-display text-xl text-ocean">Mise à l'eau…</p>
      </div>
    </div>
  );
}
